'use strict';

var credentialStatus = require('./lib/verify/credentialStatus');
var w3cVc = require('./lib/w3c-vc');
var w3cContext = require('@trustvc/w3c-context');
var types$1 = require('./lib/types');
var types = require('./lib/verify/credentialStatus/types');



Object.defineProperty(exports, "verifyCredentialStatus", {
  enumerable: true,
  get: function () { return credentialStatus.verifyCredentialStatus; }
});
Object.defineProperty(exports, "deriveCredential", {
  enumerable: true,
  get: function () { return w3cVc.deriveCredential; }
});
Object.defineProperty(exports, "isRawDocument", {
  enumerable: true,
  get: function () { return w3cVc.isRawDocument; }
});
Object.defineProperty(exports, "isSignedDocument", {
  enumerable: true,
  get: function () { return w3cVc.isSignedDocument; }
});
Object.defineProperty(exports, "signCredential", {
  enumerable: true,
  get: function () { return w3cVc.signCredential; }
});
Object.defineProperty(exports, "verifyCredential", {
  enumerable: true,
  get: function () { return w3cVc.verifyCredential; }
});
Object.defineProperty(exports, "getDocumentLoader", {
  enumerable: true,
  get: function () { return w3cContext.getDocumentLoader; }
});
Object.defineProperty(exports, "CredentialStatusResult", {
  enumerable: true,
  get: function () { return types.CredentialStatusResult; }
});
Object.keys(types$1).forEach(function (k) {
  if (k !== 'default' && !Object.prototype.hasOwnProperty.call(exports, k)) Object.defineProperty(exports, k, {
    enumerable: true,
    get: function () { return types$1[k]; }
  });
});
